import { Employee } from "../../../types/ganttChart";
import { ganttChartVerticalValues } from "../../../utils/ganttChartValues";
import { useAppSelector } from "../../../store/hooks";

const VerticalGanttChartSeparationLines = ({
  employees,
  verticalColumnWidth,
  pixelsPerHour,
}: {
  employees: Employee[];
  verticalColumnWidth: number;
  pixelsPerHour: number;
}) => {
  const { timelineRange } = useAppSelector((state) => state.timelineSlice);
  const { unplannedColumnWidth } = useAppSelector(
    (state) => state.ganttChartSlice,
  );

  const getXPositionForEmployeeColumns = (index: number) => {
    return (
      ganttChartVerticalValues.timelineColumn +
      unplannedColumnWidth +
      verticalColumnWidth +
      index * verticalColumnWidth
    );
  };

  const getXPositionForUnplannedColumn = () => {
    return ganttChartVerticalValues.timelineColumn + unplannedColumnWidth;
  };

  if (!timelineRange) return null;

  const lineHeight = timelineRange.fullDayHours * pixelsPerHour;

  return (
    <>
      <div
        style={{
          position: "absolute",
          left: getXPositionForUnplannedColumn(),
          top: 0,
          width: 1,
          height: lineHeight,
          backgroundColor: "var(--col-border-primary)",
        }}
      />
      {employees.map((_, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            left: getXPositionForEmployeeColumns(index),
            top: 0,
            width: 1,
            height: lineHeight,
            backgroundColor: "var(--col-border-primary)",
          }}
        />
      ))}
    </>
  );
};

export default VerticalGanttChartSeparationLines;
